export function ArrayToDropdownItems(items: readonly string[]) {
  return items.map((s) => ({ key: s, text: s, value: s }));
}
